import * as Yup from 'yup';

// Accepts URLs with or without a leading http:// or https://
// e.g. "example.com", "www.example.com/path", "https://example.com" all pass.
// Empty values pass — callers should layer .required() if needed.
export function isValidUrl(value) {
  if (value === undefined || value === null || value === '') return true;
  const candidate = /^https?:\/\//i.test(value) ? value : `https://${value}`;
  try {
    const { hostname } = new URL(candidate);
    return hostname.includes('.') && !hostname.startsWith('.') && !hostname.endsWith('.');
  } catch {
    return false;
  }
}

export function urlSchema(message = 'Invalid URL') {
  return Yup.string().test('is-url', message, isValidUrl);
}
